/**
 * Theme and question audio URLs: filenames from API + `REACT_APP_S3_PATH`, or absolute http(s) URLs.
 * No bundled game MP3s — admin configures files on storage (S3/CDN).
 */

function joinS3Base(filename) {
  const name = String(filename).trim().replace(/^\//, "");
  if (!name) return "";
  const baseRaw = process.env.REACT_APP_S3_PATH || "";
  const base = baseRaw.replace(/\/?$/, "/");
  return base + name;
}

/** Full URL for a theme filename in themesdata (icons, HUD MP3s, default loop). */
export function resolveThemeSoundUrl(themeData, snakeKey, camelKey) {
  if (!themeData || typeof themeData !== "object") return "";
  const raw =
    themeData[snakeKey] ?? (camelKey != null ? themeData[camelKey] : undefined);
  if (raw == null || String(raw).trim() === "") return "";
  const name = String(raw).trim();
  if (/^https?:\/\//i.test(name)) return name;
  return joinS3Base(name);
}

/** Looping “question screen” music from theme (`default_question_sound` or legacy `default_music`). */
export function resolveThemeDefaultQuestionSoundUrl(themeData) {
  const u = resolveThemeSoundUrl(themeData, "default_question_sound", "defaultQuestionSound");
  if (u) return u;
  const alt = themeData?.default_music ?? themeData?.defaultMusic;
  if (alt == null || String(alt).trim() === "") return "";
  const name = String(alt).trim();
  if (/^https?:\/\//i.test(name)) return name;
  return joinS3Base(name);
}

/** Per-question loop from `questions.music` or `music_url`. */
export function resolveQuestionMusicLoopUrl(row) {
  if (!row || typeof row !== "object") return "";
  const urlField = row.music_url ?? row.musicUrl ?? row.musicURL;
  if (urlField != null && String(urlField).trim() !== "") {
    const u = String(urlField).trim();
    if (/^https?:\/\//i.test(u)) return u;
  }
  const name = String(row.music ?? row.music_file ?? "").trim();
  if (!name) return "";
  if (/^https?:\/\//i.test(name)) return name;
  return joinS3Base(name);
}

/** True when we have a non-empty URL to pass to `new Audio(url)`. */
export function hasAudioUrl(url) {
  return url != null && String(url).trim() !== "";
}
